// extracted by mini-css-extract-plugin
export default {"box":"viewer-window_box__EWevD","expanded":"viewer-window_expanded__B2b+Z","inner":"viewer-window_inner__SclS9"};